import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Delegate your {token} to {poolName} and earn rewards',
    description: 'Just hit "Delegate" and connect your wallet',
    delegate: 'Delegate',
  },
};
